import { useState, useEffect, useRef } from "react";
import { sendMessageToAPI } from "./api";
import { musicas } from "./musicas";
import "./App.css";

export default function App() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [isLogged, setIsLogged] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [currentMode, setCurrentMode] = useState("heroi");
  const [musicaAtual, setMusicaAtual] = useState(null);
  const [limiteAtingido, setLimiteAtingido] = useState(false);
  const [showIntro, setShowIntro] = useState(true);
  const [fadeIntro, setFadeIntro] = useState(false);
  const [musicaIniciada, setMusicaIniciada] = useState(false);
  const [invokeClicked, setInvokeClicked] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const chatEndRef = useRef(null);
  const audioRef = useRef(null);
  const videoRef = useRef(null);

  const videoURL =
    "https://pub-e6c5b271b3d4433797d52ab15624cedb.r2.dev/Intro1.mp4";

  // ======= Inicialização =======
  useEffect(() => {
    localStorage.removeItem("vanhelsin_email");
    localStorage.removeItem("vanhelsin_token");
    setIsLogged(false);
    setShowIntro(true);
    setFadeIntro(false);

    const hoje = new Date().toDateString();
    const dataSalva = localStorage.getItem("vanhelsin_data");
    if (dataSalva !== hoje) {
      setLimiteAtingido(false);
      setMessages([]);
      localStorage.setItem("vanhelsin_data", hoje);
      localStorage.removeItem("vanhelsin_bloqueado");
    } else if (localStorage.getItem("vanhelsin_bloqueado") === "true") {
      setLimiteAtingido(true);
    }
  }, []);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const finishIntro = () => {
    setFadeIntro(true);
    setTimeout(() => setShowIntro(false), 800);
  };

  // ======= Login =======
  const handleLogin = (e) => {
    e.preventDefault();
    if (!email.includes("@") || senha.length < 3) {
      alert("Digite email válido e senha com pelo menos 3 caracteres");
      return;
    }
    alert("Login pulado — redirecionando para o Chat Van Helsin ⚔️");
    localStorage.setItem("vanhelsin_token", "fake-token");
    localStorage.setItem("vanhelsin_email", email);
    setIsLogged(true);
  };

  // ======= Funções auxiliares =======
  function contarPerguntasUser(messages) {
    return messages.filter((m) => m.sender === "user").length;
  }

  function fadeAudio(audioEl, targetVolume, duration, callback) {
    if (!audioEl || typeof audioEl.volume === "undefined") return;
    const step = 50;
    const steps = duration / step;
    const delta = (targetVolume - audioEl.volume) / steps;
    let count = 0;
    const fading = setInterval(() => {
      if (!audioEl || typeof audioEl.volume === "undefined") {
        clearInterval(fading);
        return;
      }
      audioEl.volume = Math.min(1, Math.max(0, audioEl.volume + delta));
      count++;
      if (count >= steps) {
        clearInterval(fading);
        if (callback) callback();
      }
    }, step);
  }

  function definirGeneroPeloProgresso(qtdPerguntas) {
    if (qtdPerguntas <= 3) return "epico";
    if (qtdPerguntas <= 7) return "calmo";
    return "apreensivo";
  }

  function tocarMusica(genero) {
    const lista = musicas[genero];
    if (!lista || lista.length === 0) return;
    let nova;
    do {
      nova = lista[Math.floor(Math.random() * lista.length)];
    } while (nova === musicaAtual && lista.length > 1);
    const audio = audioRef.current;
    if (!audio || typeof audio.volume === "undefined") return;
    fadeAudio(audio, 0, 1500, () => {
      audio.src = nova;
      audio.volume = 0;
      audio.play().catch(() => {});
      fadeAudio(audio, 1, 1500);
    });
    setMusicaAtual(nova);
  }

  // ======= Envio de mensagem =======
  const handleSend = async () => {
    if (!input.trim() || limiteAtingido) return;
    const newMsg = { text: input, sender: "user" };
    setMessages((p) => [...p, newMsg]);
    setInput("");
    const qtd = contarPerguntasUser([...messages, newMsg]);

    if (!musicaIniciada && qtd === 1) {
      setMusicaIniciada(true);
      tocarMusica("epico");
    }

    const reply = `🧠 [Simulação]: "${input}" recebido pelo modo ${currentMode}.`;
    setMessages((p) => [
      ...p,
      { text: reply, sender: "ia", mode: currentMode },
      ...(qtd === 10
        ? [
            {
              text: "🔮 O Oráculo ergueu-se nas sombras e silenciou tua voz por hoje. Retorna amanhã, peregrino...",
              sender: "ia",
              mode: currentMode,
            },
          ]
        : []),
    ]);

    if (qtd >= 10) {
      setLimiteAtingido(true);
      localStorage.setItem("vanhelsin_bloqueado", "true");
      localStorage.setItem("vanhelsin_data", new Date().toDateString());
      const audio = audioRef.current;
      if (audio) tocarMusica("apreensivo");
    }
  };

  // ======= Música contínua =======
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.onended = () => {
      const qtd = contarPerguntasUser(messages);
      const genero = definirGeneroPeloProgresso(qtd);
      tocarMusica(genero);
    };
  }, [messages, limiteAtingido]);

  const toggleMode = () =>
    setCurrentMode((p) => (p === "heroi" ? "financeiro" : "heroi"));

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setMessages((p) => [
      ...p,
      { text: `📄 [Simulação] Upload concluído: ${file.name}`, sender: "upload" },
    ]);
    e.target.value = "";
  };

  // ======= INTRO =======
  if (showIntro) {
    return (
      <div className={`intro-container ${fadeIntro ? "fade-out" : ""}`}>
        {/* 🎬 VÍDEO (R2) — aparece 4s após trovão */}
        <video
          ref={videoRef}
          className="intro-video"
          src={videoURL}
          muted
          playsInline
          preload="auto"
          crossOrigin="anonymous"
          onEnded={finishIntro}
          onError={(e) => console.error("❌ Erro no vídeo:", e)}
          style={{
            filter: "brightness(0.85)",
            opacity: showVideo ? 1 : 0,
            transition: "opacity 1s ease-in-out",
            zIndex: 1,
          }}
        />

        <div id="flash" className="flash-effect"></div>

        {!invokeClicked && (
          <div className="invoke-btn-container fade-in">
            <button
              className="invoke-btn"
              onClick={() => {
                setInvokeClicked(true);
                try {
                  const thunder = new Audio(
                    process.env.PUBLIC_URL + "/sounds/thunder.mp3"
                  );
                  thunder.volume = 1.0;
                  thunder.play().then(() => {
                    thunder.currentTime = 0;
                    thunder.play();
                    setTimeout(() => {
                      const echo = new Audio(
                        process.env.PUBLIC_URL + "/sounds/thunder.mp3"
                      );
                      echo.volume = 0.6;
                      echo.play().catch(() => {});
                    }, 600);
                  });
                } catch {}
                const flash = document.getElementById("flash");
                if (flash) {
                  flash.classList.add("active");
                  setTimeout(() => flash.classList.remove("active"), 400);
                }
                document.body.classList.add("shake");
                setTimeout(() => document.body.classList.remove("shake"), 500);

                // 🎬 Exibir o vídeo 4s após o trovão
                setTimeout(() => {
                  setShowVideo(true);
                  const video = videoRef.current;
                  if (video) {
                    video.muted = false;
                    video.play().catch(() => {});
                    video.volume = 0;
                    const fade = setInterval(() => {
                      if (!video) return clearInterval(fade);
                      if (video.volume < 0.95) video.volume += 0.05;
                      else clearInterval(fade);
                    }, 120);
                  }
                }, 4000);
              }}
            >
              ⚡ Atreva-se a Invocar Van Helsin ⚡
            </button>
          </div>
        )}

        {/* 🔘 Botão “Pular Intro” (fixo sobre o vídeo) */}
        <div className="intro-buttons" style={{ zIndex: 5 }}>
          <button className="skip-button gothic-btn" onClick={finishIntro}>
            Pular Intro
          </button>
        </div>
      </div>
    );
  }

  // ======= LOGIN =======
  if (!isLogged) {
    return (
      <div className="flex items-center justify-center h-screen bg-black text-white gothic-text">
        <form
          onSubmit={handleLogin}
          className="bg-gray-900 p-8 rounded-2xl shadow-lg flex flex-col items-center"
        >
          <h1 className="text-3xl font-bold mb-4 text-red-600 gothic-text">
            ☩ LOGIN VAN HELSIN ☩
          </h1>
          <p className="mb-4 text-gray-400 gothic-text">
            Digite email e senha para despertar o Caçador
          </p>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="seu@email.com"
            className="w-64 p-2 rounded bg-black border border-red-600 text-white focus:outline-none"
            required
          />
          <input
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="sua senha"
            className="w-64 p-2 rounded bg-black border border-red-600 text-white focus:outline-none mt-2"
            required
          />
          <button
            type="submit"
            className="mt-4 px-6 py-2 bg-red-700 hover:bg-red-900 rounded gothic-btn"
          >
            Entrar
          </button>
        </form>
      </div>
    );
  }

  // ======= CHAT =======
  return (
    <div className="app gothic-text">
      <div
        className="background"
        style={{ backgroundImage: "url('/fotos/vanhelsin.jpg')" }}
      />
      <div className="top-bar">
        <h1 className="text-glow">
          ⚔️ Van Helsin IA —{" "}
          {currentMode === "heroi"
            ? "Herói das Sombras"
            : "Exorcista Financeiro"}
        </h1>
        <div>
          <button className="btn gothic-btn" onClick={toggleMode}>
            Trocar IA
          </button>
          <label
            className="btn upload-label gothic-btn"
            style={{ marginLeft: "10px" }}
          >
            📄 Upload
            <input type="file" accept=".pdf,.txt" onChange={handleUpload} />
          </label>
        </div>
      </div>

      <div className="chat">
        {messages.map((m, idx) => {
          let cls = "msg fade-in",
            pref = "";
          if (m.sender === "user") {
            cls += " user-msg";
            pref = "Você";
          } else if (m.sender === "upload") {
            cls += " upload-msg";
            pref = "📄 Upload";
          } else if (m.sender === "ia") {
            if (m.mode === "heroi") {
              cls += " ia-heroi";
              pref = "Herói das Sombras";
            } else {
              cls += " ia-financeiro";
              pref = "Exorcista Financeiro";
            }
          }
          return (
            <div key={idx} className={cls}>
              <strong>{pref}:</strong> {m.text}
            </div>
          );
        })}
        <div ref={chatEndRef} />
      </div>

      <div className="input-bar">
        <input
          type="text"
          placeholder={
            limiteAtingido
              ? "⚠️ O Oráculo silenciou-te por hoje..."
              : currentMode === "heroi"
              ? "Fale com o Herói das Sombras..."
              : "Fale com o Exorcista Financeiro..."
          }
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          className={
            currentMode === "heroi" ? "input-heroi" : "input-financeiro"
          }
          disabled={limiteAtingido}
        />
        <button
          onClick={handleSend}
          disabled={limiteAtingido}
          className="send-btn gothic-btn"
        >
          {limiteAtingido ? "Bloqueado" : "Enviar"}
        </button>
      </div>

      <audio ref={audioRef} loop hidden preload="auto" />

      {process.env.NODE_ENV !== "production" && (
        <div
          id="oraculo-btn"
          style={{ bottom: "90px" }}
          onClick={() => {
            localStorage.removeItem("vanhelsin_bloqueado");
            localStorage.removeItem("vanhelsin_data");
            setLimiteAtingido(false);
            setMessages([]);
            alert(
              "🔮 O Oráculo foi purificado. Tuas perguntas podem ecoar novamente."
            );
          }}
        >
          🩸 Limpar Bloqueio do Oráculo
        </div>
      )}
    </div>
  );
}
